module.exports = __webpack_public_path__ + "static/media/indeco-logo-app-bar.ef339191.png";